import api from "../../../services/api";

const BASE_URL = "/api/v1/preboarding";

export const preBoardingService = {
  // Create pre-boarding packet from accepted offer
  createPacket: async (offerId) => {
    try {
      const response = await api.post(`${BASE_URL}/offer/${offerId}`);
      return response.data;
    } catch (error) {
      console.error("Error creating pre-boarding packet:", error);
      throw error;
    }
  },

  // Get all pre-boarding packets (HR dashboard)
  getAllPackets: async (params = {}) => {
    try {
      const response = await api.get(BASE_URL, { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching pre-boarding packets:", error);
      throw error;
    }
  },

  // Get single pre-boarding packet by ID
  getPacketById: async (packetId) => {
    try {
      const response = await api.get(`${BASE_URL}/${packetId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching pre-boarding packet:", error);
      throw error;
    }
  },

  // Get pre-boarding packet by offer ID (for candidate portal)
  getPacketByOffer: async (offerId) => {
    try {
      const response = await api.get(`${BASE_URL}/offer/${offerId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching packet by offer:", error);
      throw error;
    }
  },

  // Upload document to pre-boarding packet
  uploadDocument: async (packetId, documentIndex, file) => {
    try {
      const formData = new FormData();
      formData.append("document", file);

      const response = await api.post(
        `${BASE_URL}/${packetId}/documents/${documentIndex}/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error uploading document:", error);
      throw error;
    }
  },

  // Download document from pre-boarding packet
  downloadDocument: async (packetId, documentIndex) => {
    try {
      const response = await api.get(
        `${BASE_URL}/${packetId}/documents/${documentIndex}/download`,
        {
          responseType: "blob",
        }
      );
      return response;
    } catch (error) {
      console.error("Error downloading document:", error);
      throw error;
    }
  },

  // Verify or reject document (HR action)
  verifyDocument: async (packetId, documentIndex, action, comments = "") => {
    try {
      const response = await api.put(
        `${BASE_URL}/${packetId}/documents/${documentIndex}/verify`,
        {
          action,
          comments,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error verifying document:", error);
      throw error;
    }
  },

  // Send reminder email to candidate
  sendReminder: async (packetId) => {
    try {
      const response = await api.post(`${BASE_URL}/${packetId}/reminder`);
      return response.data;
    } catch (error) {
      console.error("Error sending reminder:", error);
      throw error;
    }
  },

  // Get dashboard statistics
  getStats: async () => {
    try {
      const response = await api.get(`${BASE_URL}/stats`);
      return response.data;
    } catch (error) {
      console.error("Error fetching pre-boarding stats:", error);
      throw error;
    }
  },
};

export default preBoardingService;
